import { render, staticRenderFns } from "./calendreItem.vue?vue&type=template&id=fbb94cf2&scoped=true&"
import script from "./calendreItem.vue?vue&type=script&lang=js&"
export * from "./calendreItem.vue?vue&type=script&lang=js&"
import style0 from "./calendreItem.vue?vue&type=style&index=0&id=fbb94cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb94cf2",
  null
  
)

export default component.exports